import React from 'react';
import {IKnowledgeQuestion} from '../../hooks/apis/useKnowledgeQuestion';
import Paragraph from 'antd/lib/typography/Paragraph';

export default function KnowLedgeQuestionDisplayItem(props: {question: IKnowledgeQuestion}) {
  return (
    <div>
      <Paragraph strong>{props.question.topic}</Paragraph>
      {props.question.rightOptions.map((o, i) => (
        <Paragraph key={i} type={'success'}>
          {o}
        </Paragraph>
      ))}
      {props.question.wrongOptions.map((o, i) => (
        <Paragraph key={i}>{o}</Paragraph>
      ))}
    </div>
  );
}
